export const issueProfileNameCellRules = {
	'grid-issue-profile-name': params => {
		if (params.data) {
			return params.data.Name;
		}
	},
};
